"use strict";

exports.__esModule = true;
exports.definitionForModuleAndIdentifier = definitionForModuleAndIdentifier;
exports.definitionForModuleWithContextAndKey = definitionForModuleWithContextAndKey;
exports.definitionsFromContext = definitionsFromContext;
exports.identifierForContextKey = identifierForContextKey;
/*
Stimulus Webpack Helpers 1.0.0
Copyright © 2021 Basecamp, LLC
 */
function definitionsFromContext(context) {
  return context.keys().map(function (key) {
    return definitionForModuleWithContextAndKey(context, key);
  }).filter(function (value) {
    return value;
  });
}
function definitionForModuleWithContextAndKey(context, key) {
  var identifier = identifierForContextKey(key);
  if (identifier) {
    return definitionForModuleAndIdentifier(context(key), identifier);
  }
}
function definitionForModuleAndIdentifier(module, identifier) {
  var controllerConstructor = module.default;
  if (typeof controllerConstructor == "function") {
    return {
      identifier: identifier,
      controllerConstructor: controllerConstructor
    };
  }
}
function identifierForContextKey(key) {
  var logicalName = (key.match(/^(?:\.\/)?(.+)(?:[_-]controller\..+?)$/) || [])[1];
  if (logicalName) {
    return logicalName.replace(/_/g, "-").replace(/\//g, "--");
  }
}